import {Injectable} from '@angular/core';
import {Meta, MetaDefinition} from '@angular/platform-browser';
import {UrlBuilderService} from './url-builder.service';
import {QueryParams} from '../types/QueryParams';

@Injectable()
export class HeaderRedirectService {
  constructor(
    private metaService: Meta,
    private urlBuilder: UrlBuilderService
  ) {}

  redirect(routeLinkTab: string[], queryParams: QueryParams): void {
    const url: string = this.urlBuilder.CreateStaticLink(
      routeLinkTab,
      queryParams
    );
    const tag: MetaDefinition = {'http-Equiv': 'refresh', content: `0; ${url}`};
    this.metaService.addTag(tag);
  }
}
